import shallow from 'zustand/shallow';
import { useUserState } from '@root/state';
import { IUser } from '@root/types/user';
const useUser = (): {
  user: IUser;
  setUser: (v: IUser) => void;
} => {
  const { user, setUser } = useUserState(
    (state) => ({
      user: state.user,
      setUser: state.setUser,
    }),
    shallow,
  );

  return { user, setUser };
};

const useUserId = (): string => {
  const { user } = useUser();
  return user.id || '';
};

export { useUserId };

export default useUser;
